/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import {
    useInfiniteQuery,
    useMutation,
    useQuery,
    useSuspenseQuery,
} from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseInfiniteQueryResult,
    DefinedUseQueryResult,
    InfiniteData,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    EventAndRelationsPaginatedListDto,
    GetApiScopes200,
    GetUserEventsLatestParams,
    GetUserEventsParams,
    HealthReport,
    PendoData,
    UserStatus,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getApiScopes = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<GetApiScopes200>> => {
    return axios.get(`/api/api-scopes`, options);
};

export const getGetApiScopesQueryKey = () => {
    return [`/api/api-scopes`] as const;
};

export const getGetApiScopesQueryOptions = <
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getApiScopes>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetApiScopesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiScopes>>> = ({
        signal,
    }) => getApiScopes({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getApiScopes>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiScopesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getApiScopes>>
>;
export type GetApiScopesQueryError = AxiosError<unknown>;

export function useGetApiScopes<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getApiScopes>>,
                    TError,
                    Awaited<ReturnType<typeof getApiScopes>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiScopes<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getApiScopes>>,
                    TError,
                    Awaited<ReturnType<typeof getApiScopes>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiScopes<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiScopes<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetApiScopesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetApiScopesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getApiScopes>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetApiScopesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiScopes>>> = ({
        signal,
    }) => getApiScopes({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiScopes>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiScopesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getApiScopes>>
>;
export type GetApiScopesSuspenseQueryError = AxiosError<unknown>;

export function useGetApiScopesSuspense<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiScopesSuspense<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiScopesSuspense<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiScopesSuspense<
    TData = Awaited<ReturnType<typeof getApiScopes>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getApiScopes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetApiScopesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getHealth = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<HealthReport>> => {
    return axios.get(`/api/health`, options);
};

export const getGetHealthQueryKey = () => {
    return [`/api/health`] as const;
};

export const getGetHealthQueryOptions = <
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({
        signal,
    }) => getHealth({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getHealth>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHealthQueryResult = NonNullable<
    Awaited<ReturnType<typeof getHealth>>
>;
export type GetHealthQueryError = AxiosError<HealthReport>;

export function useGetHealth<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getHealth>>,
                    TError,
                    Awaited<ReturnType<typeof getHealth>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHealth<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getHealth>>,
                    TError,
                    Awaited<ReturnType<typeof getHealth>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHealth<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetHealth<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetHealthQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetHealthSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getHealth>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({
        signal,
    }) => getHealth({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getHealth>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHealthSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getHealth>>
>;
export type GetHealthSuspenseQueryError = AxiosError<HealthReport>;

export function useGetHealthSuspense<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHealthSuspense<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHealthSuspense<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetHealthSuspense<
    TData = Awaited<ReturnType<typeof getHealth>>,
    TError = AxiosError<HealthReport>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getHealth>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetHealthSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPendoData = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PendoData>> => {
    return axios.get(`/api/pendo-data`, options);
};

export const getGetPendoDataQueryKey = () => {
    return [`/api/pendo-data`] as const;
};

export const getGetPendoDataQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getPendoData>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPendoDataQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendoData>>> = ({
        signal,
    }) => getPendoData({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPendoData>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendoDataQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendoData>>
>;
export type GetPendoDataQueryError = AxiosError<unknown>;

export function useGetPendoData<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendoData>>,
                    TError,
                    Awaited<ReturnType<typeof getPendoData>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendoData<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendoData>>,
                    TError,
                    Awaited<ReturnType<typeof getPendoData>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendoData<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendoData<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendoDataQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPendoDataSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getPendoData>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPendoDataQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendoData>>> = ({
        signal,
    }) => getPendoData({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPendoData>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendoDataSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendoData>>
>;
export type GetPendoDataSuspenseQueryError = AxiosError<unknown>;

export function useGetPendoDataSuspense<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendoDataSuspense<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendoDataSuspense<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendoDataSuspense<
    TData = Awaited<ReturnType<typeof getPendoData>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendoData>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendoDataSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postSetLocizeCookie = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(`/api/set-locize-cookie`, undefined, options);
};

export const getPostSetLocizeCookieMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postSetLocizeCookie>>,
        TError,
        void,
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postSetLocizeCookie>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ["postSetLocizeCookie"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postSetLocizeCookie>>,
        void
    > = () => {
        return postSetLocizeCookie(axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostSetLocizeCookieMutationResult = NonNullable<
    Awaited<ReturnType<typeof postSetLocizeCookie>>
>;

export type PostSetLocizeCookieMutationError = AxiosError<unknown>;

export const usePostSetLocizeCookie = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postSetLocizeCookie>>,
            TError,
            void,
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postSetLocizeCookie>>,
    TError,
    void,
    TContext
> => {
    return useMutation(
        getPostSetLocizeCookieMutationOptions(options),
        queryClient
    );
};
export const getUserEvents = (
    params: GetUserEventsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EventAndRelationsPaginatedListDto>> => {
    return axios.get(`/api/user-events`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUserEventsInfiniteQueryKey = (
    params?: GetUserEventsParams
) => {
    return [
        "infinite",
        `/api/user-events`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetUserEventsQueryKey = (params?: GetUserEventsParams) => {
    return [`/api/user-events`, ...(params ? [params] : [])] as const;
};

export const getGetUserEventsInfiniteQueryOptions = <
    TData = InfiniteData<
        Awaited<ReturnType<typeof getUserEvents>>,
        GetUserEventsParams["page"]
    >,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getUserEvents>>,
                QueryKey,
                GetUserEventsParams["page"]
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserEventsInfiniteQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserEvents>>,
        QueryKey,
        GetUserEventsParams["page"]
    > = ({ signal, pageParam }) =>
        getUserEvents(
            { ...params, page: pageParam ?? params?.["page"] },
            { signal, ...axiosOptions }
        );

    return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getUserEvents>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getUserEvents>>,
        QueryKey,
        GetUserEventsParams["page"]
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEventsInfiniteQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserEvents>>
>;
export type GetUserEventsInfiniteQueryError = AxiosError<unknown>;

export function useGetUserEventsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getUserEvents>>,
        GetUserEventsParams["page"]
    >,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options: {
        query: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getUserEvents>>,
                QueryKey,
                GetUserEventsParams["page"]
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEvents>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEvents>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getUserEvents>>,
        GetUserEventsParams["page"]
    >,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getUserEvents>>,
                QueryKey,
                GetUserEventsParams["page"]
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEvents>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEvents>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getUserEvents>>,
        GetUserEventsParams["page"]
    >,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getUserEvents>>,
                QueryKey,
                GetUserEventsParams["page"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserEventsInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getUserEvents>>,
        GetUserEventsParams["page"]
    >,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getUserEvents>>,
                QueryKey,
                GetUserEventsParams["page"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserEventsInfiniteQueryOptions(params, options);

    const query = useInfiniteQuery(
        queryOptions,
        queryClient
    ) as UseInfiniteQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserEventsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserEventsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEvents>>> = ({
        signal,
    }) => getUserEvents(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEventsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserEvents>>
>;
export type GetUserEventsQueryError = AxiosError<unknown>;

export function useGetUserEvents<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEvents>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEvents>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEvents<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEvents>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEvents>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEvents<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserEvents<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserEventsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserEventsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserEventsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEvents>>> = ({
        signal,
    }) => getUserEvents(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEventsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserEvents>>
>;
export type GetUserEventsSuspenseQueryError = AxiosError<unknown>;

export function useGetUserEventsSuspense<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsSuspense<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsSuspense<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserEventsSuspense<
    TData = Awaited<ReturnType<typeof getUserEvents>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEvents>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserEventsSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUserEventsLatest = (
    params: GetUserEventsLatestParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EventAndRelationsPaginatedListDto>> => {
    return axios.get(`/api/user-events/latest`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUserEventsLatestQueryKey = (
    params?: GetUserEventsLatestParams
) => {
    return [`/api/user-events/latest`, ...(params ? [params] : [])] as const;
};

export const getGetUserEventsLatestQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserEventsLatestQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserEventsLatest>>
    > = ({ signal }) =>
        getUserEventsLatest(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserEventsLatest>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEventsLatestQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserEventsLatest>>
>;
export type GetUserEventsLatestQueryError = AxiosError<unknown>;

export function useGetUserEventsLatest<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEventsLatest>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEventsLatest>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsLatest<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserEventsLatest>>,
                    TError,
                    Awaited<ReturnType<typeof getUserEventsLatest>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsLatest<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserEventsLatest<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserEventsLatestQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserEventsLatestSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserEventsLatestQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserEventsLatest>>
    > = ({ signal }) =>
        getUserEventsLatest(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserEventsLatest>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEventsLatestSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserEventsLatest>>
>;
export type GetUserEventsLatestSuspenseQueryError = AxiosError<unknown>;

export function useGetUserEventsLatestSuspense<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsLatestSuspense<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEventsLatestSuspense<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserEventsLatestSuspense<
    TData = Awaited<ReturnType<typeof getUserEventsLatest>>,
    TError = AxiosError<unknown>,
>(
    params: GetUserEventsLatestParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserEventsLatest>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserEventsLatestSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUserStatus = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserStatus>> => {
    return axios.get(`/api/user-status`, options);
};

export const getGetUserStatusQueryKey = () => {
    return [`/api/user-status`] as const;
};

export const getGetUserStatusQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getUserStatus>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserStatusQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatus>>> = ({
        signal,
    }) => getUserStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserStatusQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserStatus>>
>;
export type GetUserStatusQueryError = AxiosError<unknown>;

export function useGetUserStatus<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getUserStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserStatus<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserStatus>>,
                    TError,
                    Awaited<ReturnType<typeof getUserStatus>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserStatus<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserStatus<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserStatusQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserStatusSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getUserStatus>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserStatusQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatus>>> = ({
        signal,
    }) => getUserStatus({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserStatusSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserStatus>>
>;
export type GetUserStatusSuspenseQueryError = AxiosError<unknown>;

export function useGetUserStatusSuspense<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserStatusSuspense<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserStatusSuspense<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserStatusSuspense<
    TData = Awaited<ReturnType<typeof getUserStatus>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserStatus>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserStatusSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
